import {
  Button,
  Col,
  Form,
  Input,
   Modal,
  Row,
  Select,
} from "antd";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { selectTime } from "../../utils/helper/constants";
import {
  formatDateFunction,
  formatDateFunctionNew,
} from "../../utils/helper/utils";
import globalRequest from "../../utils/global/globalRequest";
import * as Apis from "../../utils/helper/enum";
import { changeLoader } from "../../redux/reducers/loader";
import toast from "react-hot-toast";
import ConfirmationModal from "../../Modal/ConfirmationModal";
const daysName = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

const DriverAddSlot = ({ isOpen, onOk, onCancel, selectedDate, data, holidayData, onSubmit }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  let { id } = useParams();

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  // const [itemData,setItemData] = useState(false);

  const [holidayDescription, setHolidayDescription] = useState("");

  useEffect(() => {
    if (selectedDate && holidayData && holidayData.length > 0) {
      const dateStr = formatDateFunction(new Date(selectedDate), "yyyy-mm-dd");
      const found = holidayData.find((h) => {
        const start = formatDateFunction(new Date(h.startDate), "yyyy-mm-dd");
        const end = formatDateFunction(new Date(h.endDate), "yyyy-mm-dd");
        return dateStr >= start && dateStr <= end;
      });
      if (found) {
        setHolidayDescription(found.description || "Holiday");
      } else {
        setHolidayDescription("");
      }
    } else {
      setHolidayDescription("");
    }
  }, [selectedDate, holidayData]);

  const handleInputChange = (name) => {
    form.setFields([
      {
        name,
        errors: [],
      },
    ]);
  };
  const handleSubmit = async () => {
    try {
      // Validate and get the form values
      const values = await form.validateFields();
      let slotId = data ? (data?._id || data?.id) : 0;
      values.date = selectedDate;

      if (
        values.openTime &&
        values.closeTime &&
        values.closeTime <= values.openTime
      ) {
        form.setFields([
          {
            name: "closeTime",
            errors: ["Please select correct time."],
          },
        ]);
        return false;
      }
      if (values.total_trip_distance < 0) {
        form.setFields([
          {
            name: "total_trip_distance",
            errors: ["Total trip distance must be a positive number!"],
          },
        ]);
        return false;
      }
      if (values.discount > 100) {
        form.setFields([
          {
            name: "discount",
            errors: ["Discount must be a less then 100"],
          },
        ]);
        return false;
      }

      let date = values.date ? new Date(values.date) : null;
      let day = date && !isNaN(date.getTime()) ? daysName[date.getDay()].toLowerCase() : data?.day || "monday";

      let insertData = {
        driverId: id,
        type: data?.type,
        day: day,
        date: formatDateFunction(date, "yyyy-mm-dd"),
        openTime: values.openTime,
        closeTime: values.closeTime,
        total_trip_distance: Number(values.total_trip_distance),
        id: slotId,
        api_type: "edit",
      };

      dispatch(changeLoader(true));
      try {
        let url = Apis?.DRIVER_TIME_SLOTE?.CREATE_DATE_SLOT;
        let method = "post";
        if (slotId) {
          url = Apis?.DRIVER_TIME_SLOTE?.UPDATE_DATE_SLOT;
          method = "put";
        }
        let response = await globalRequest(url, method, insertData, {}, true);
        let apiResponse = response?.data;
        if (response?.status === 200) {
          let msg = "Slot created successfully";
          if (slotId) msg = "Slot updated successfully";
          toast.success(msg, {
            duration: 2000,
          });
          onSubmit?.();
          form.resetFields();
          onOk();
        } else {
          toast.error(apiResponse?.message);
        }
      } catch (e) {
        toast.error(e?.message);
      }
      dispatch(changeLoader(false));
    } catch (error) {
      console.error("Form validation failed:", error);
    }
  };

  useEffect(() => {
    if (data) {
      form.setFieldValue("openTime", data?.startTime || data?.openTime);
      form.setFieldValue("closeTime", data?.endTime || data?.closeTime);
      form.setFieldValue("total_trip_distance", data?.total_trip_distance || data?.tripDistance || data?.capacity);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handleDeleteOk = async () => {
    setIsDeleteModalOpen(false);
    try {
      dispatch(changeLoader(true));
      let response = await globalRequest(
        Apis?.DRIVER_TIME_SLOTE?.DELETE_TIME_SLOT + "/" + (data?.id || data?._id),
        "put",
        {},
        {},
        true
      );
      if (response?.status === 200) {
        let msg = "Time slot deleted successfully";
        toast.success(msg, {
          duration: 2000,
        });
        onSubmit?.();
        form.resetFields();
        onOk();
      } else {
        toast.error(response?.data?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    } finally {
      dispatch(changeLoader(false));
    }
  };
  const handleDeleteCancel = () => {
    setIsDeleteModalOpen(false);
  };

  return (
    <>
      <Modal
        title={data?.id || data?._id ? "Edit Slot" : "Add Slot"}
        centered
        open={isOpen}
        onCancel={onCancel}
        footer={
          <Row style={{ width: "100%" }}>
            <Col span={12} style={{ textAlign: "left" }}>
              {/* Delete will only show when the time slot is edited. */}
              {data?.id || data?._id ? (
                <div
                  className="text-red-700 font-semibold text-base mt-1 cursor-pointer"
                  onClick={() => {
                    // setItemData(data);
                    setIsDeleteModalOpen(true);
                  }}
                >
                  Delete
                </div>
              ) : null}
            </Col>
            <Col span={12} style={{ textAlign: "right" }}>
              <Button
                key="back"
                onClick={onCancel}
                className="mx-2.5 cursor-pointer"
              >
                Cancel
              </Button>
              <Button key="save" type="primary" onClick={handleSubmit} disabled={!!holidayDescription}>
                Save
              </Button>
            </Col>
          </Row>
        }
        okText="Save"
        width={600}
      >
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            remember: true,
          }}
          style={{ marginTop: 24 }}
          autoComplete="off"
        >
          <div className="text-lg mb-5 font-semibold">
            {formatDateFunctionNew(selectedDate)}
          </div>
          {holidayDescription && (
            <div className="mb-5 p-3 bg-red-50 border border-red-200 text-red-800 rounded-lg font-medium text-sm">
              Note: This date is set as a holiday ({holidayDescription}). Saving slots on this date is not allowed.
            </div>
          )}
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Open Time"
                name="openTime"
                rules={[
                  {
                    required: true,
                    message: "Please Select Your Open Time.",
                  },
                ]}
              >
                <Select
                  size="large"
                  placeholder="Select"
                  options={selectTime}
                  showSearch
                  filterOption={(input, selectTime) =>
                    (selectTime?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  className="w-[200px]"
                  onChange={(date, dateString) => {
                    form.setFieldValue("openTime", date);
                    handleInputChange("openTime");
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Close Time"
                name="closeTime"
                rules={[
                  {
                    required: true,
                    message: "Please Select Your Close Time.",
                  },
                ]}
              >
                <Select
                  size="large"
                  placeholder="Select"
                  options={selectTime}
                  showSearch
                  filterOption={(input, selectTime) =>
                    (selectTime?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  onChange={(value) => {
                    form.setFieldValue("closeTime", value);
                    handleInputChange("closeTime");
                  }}
                  className="w-[200px]"
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item
            label="Total Trip Distance"
            name="total_trip_distance"
            rules={[
              {
                required: true,
                message: "Please enter your Total Trip Distance!",
              },
              {
                validator: (_, value) => {
                  if (value === 0 || (value && Number.isInteger(Number(value)) && value.toString().length <= 8)) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Invalid distance"));
                },
              },
            ]}
          >
            <Input size="large" min={0} type="number" addonAfter="Km" />
          </Form.Item>

          <div className="text-sm mb-5 text-gray-150">
            You are editing this day's shifts only, To set regular shifts, go to
            working hours.
          </div>
        </Form>
      </Modal>
      {/* delete modal */}
      {isDeleteModalOpen && (
        <ConfirmationModal
          ConfirmationHeading="Delete"
          ConfirmationParagraph="Are you sure you want to delete this timeslot?"
          isOpen={isDeleteModalOpen}
          onOk={handleDeleteOk}
          onCancel={handleDeleteCancel}
        />
      )}
    </>
  );
};
export default DriverAddSlot;
